import script from "./ProjectPerson.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectPerson.vue?vue&type=script&setup=true&lang=js"

import "./ProjectPerson.vue?vue&type=style&index=0&id=35f95f40&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f95f40"]])

export default __exports__